module.exports = __webpack_public_path__ + "c8e5797adaffb510c550bac559f0f75d.svg";